import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event: InputEvent) {
    const includeContact = (event.currentTarget as HTMLInputElement).checked

    const shadowPages = document.querySelectorAll<HTMLElement>(
      "[data-slide-type='about-me'] shadow-page",
    )
    if (shadowPages.length === 0) return

    shadowPages.forEach((shadowPage) => {
      const shadowRoot = shadowPage.shadowRoot
      if (!shadowRoot) return

      const contactSections = shadowRoot.querySelectorAll<HTMLElement>(".clean-contact-section")
      contactSections.forEach((section) => {
        section.style.display = includeContact ? "" : "none"
      })

      const questionRows = shadowRoot.querySelectorAll<HTMLElement>(".clean-questions-row")
      questionRows.forEach((row) => {
        const includedHeight = row.dataset.contactIncludedHeight
        const excludedHeight = row.dataset.contactExcludedHeight
        if (!includedHeight || !excludedHeight) return
        const height = includeContact ? includedHeight : excludedHeight
        row.style.height = `calc(var(--page-height)*${height})`
      })
    })
  }
}
